import { render } from "./InputVerifyCode.vue?vue&type=template&id=5015df6b&lang=pug"
import script from "./InputVerifyCode.vue?vue&type=script&lang=js"
export * from "./InputVerifyCode.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__